module.exports = "/_next/static/images/slide12-e39f1f661cfd1f82ecb28100559139a5.webp";